enum DisplayNames {
  Card = 'Card',
  CardContent = 'CardContent',
  CardContentBody = 'CardContentBody',
  CardContentHeading = 'CardContentHeading',
  CardFooter = 'CardFooter',
  CardHeader = 'CardHeader'
}

export default DisplayNames;
